<template>
	<el-row style="position: absolute; top: 20px;">
		<el-col>
			<el-input style="opacity: 0.8; height: 28px;" size="small" v-model="computedUsername" placeholder="用户名" clearable maxlength="16" minlength="6" show-word-limit/>
			<el-input size="small" v-model="password" placeholder="密码" style="margin-top:5px;opacity: 0.8;height: 28px;"
				clearable show-password maxlength="16" minlength="6" show-word-limit/>
		</el-col>
	</el-row>

	<el-row class="ckbtn">
		<el-col>
			<el-button type="danger" style="margin-top: 6px; width: 100%; height: 50px;" @click="打开提示窗" :disabled="按下按钮">解绑其他设备</el-button>
		</el-col>
	</el-row>


</template>

<script>
	import axios from 'axios'
	import {
		useStore
	} from 'vuex'
	import {
		ElMessage,
		ElMessageBox
	} from 'element-plus';
	import {
		computed,
		ref
	} from 'vue'
	import {
		defineComponent,
		onMounted
	} from 'vue';
	export default defineComponent({
		name: 'huanbang',
		setup() {
			const store = useStore()
			const localport = computed(() => store.state.localport)
			const is_login_A = computed(() => store.state.is_login_A)
			const username_global = computed(() => store.state.username_global)
			
			const computedUsername = computed({
			      get: () => store.state.username_global,
			      set: (value) => {
			        // 在这里设置 computedUsername 的值，这将影响到 store.state.username_global
			        store.commit('set_username_global', value) // 假设使用 Vuex 来管理状态
			      },
			    })
				
			const password = ref("")
			const 记住密码 = ref(false)
			const 按下按钮 = ref(false)
			
			const 打开提示窗 = () => {
				ElMessageBox.confirm(
						'换绑机器将扣除八小时时长，确定要换绑到此机器吗?',
						'提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning',
						}
					)
					.then(() => {

						执行换绑()
				
					})
					.catch(() => {
						ElMessage({
							type: 'info',
							message: '取消换绑',
						})
					})
			}
			

			const 执行换绑 = async () => {
				try {
					按下按钮.value = true
					// 在 API 调用前延迟 5 秒
					// await new Promise(resolve => setTimeout(resolve, 1000)); // 5000 毫秒即 5 秒
					// console.log("A1")
					const response = await axios.post('http://localhost:' + localport.value +
						'/api/v1/async_huanbang', {
							"username": username_global.value,
							"password": password.value,
						});
					// console.log("A2")
					// 根据接口返回的状态码是否为 200，修改变量 unturned_path 的值
					if (response.status === 200 && response.data.code === 200) {
						ElMessage.success(response.data.msg);
					} else {
						ElMessage.error(response.data.msg);
					}
				} catch (error) {
					console.log(error)

				} finally {
					按下按钮.value = false
				}

			};

			return {
				username_global,
				password,
				按下按钮,
				打开提示窗,
				computedUsername
			}
		}
	});
</script>

<style scoped>
	.notice {
		height: 124px;
		max-height: 124px;
		/* 设置最大高度为200像素，可以根据需要调整 */
		overflow-y: auto;
		font-size: 12px;
		/* font-family: 'Noto Sans SC', sans-serif; */
		font-weight: 500;
		/* 设置粗体样式 */
		margin-top: 26px;
		color: white;

	}

	.el-button--danger {
		background-color: darkred;
		border-color: darkred;
	}

	.ckbtn {
		width: 100%;
		position: absolute;
		top: 100px;
	}
</style>